import styles from "./TooltipMessage.module.scss";

interface TooltipMessageProps {
  title: string;
  description?: string;
  hint?: string;
  testId?: string;
}

const TooltipMessage = (props: TooltipMessageProps) => {
  const { title, description, testId, hint } = props;

  return (
    <div
      className={styles.root}
      data-testid={testId ?? "tooltip-message"}
    >
      <div className={styles.title}>{title}</div>
      {!!description && <div className={styles.description}>{description}</div>}
      {!!hint && <div className={styles.hint}>{hint}</div>}
    </div>
  );
};

export default TooltipMessage;
